/**
 * Redux Actions for V2 Authentication System
 * Handles login state management with new API structure
 */

import {
  setAccessToken,
  setUserData,
  setSessionId,
  clearAuthData,
  initializeAuthData
} from "../../utils/authV2/tokenManager"

/**
 * Handle successful login (2FA OFF)
 * @param {Object} responseData - Login API response data
 * @param {string} responseData.access_token - Access token
 * @param {Object} responseData.user_detail - User detail object
 */
export const handleLoginV2 = (responseData) => {
  return (dispatch) => {
    // Initialize auth data
    initializeAuthData(responseData)

    // Dispatch Redux action
    dispatch({
      type: "LOGIN_V2",
      payload: {
        accessToken: responseData.access_token,
        userData: responseData.user_detail,
        isAuthenticated: true
      }
    })
  }
}

/**
 * Handle 2FA required (OTP sent)
 * @param {Object} responseData - Login API response data
 * @param {string} responseData.session_id - Session ID for OTP verification
 */
export const handle2FARequired = (responseData) => {
  return (dispatch) => {
    // Store session ID for OTP verification
    if (responseData.session_id) {
      setSessionId(responseData.session_id)
    }

    // Dispatch Redux action
    dispatch({
      type: "2FA_REQUIRED",
      payload: {
        sessionId: responseData.session_id,
        requiresOtp: true
      }
    })
  }
}

/**
 * Handle OTP verification success
 * @param {Object} responseData - OTP verification API response data
 * @param {string} responseData.access_token - Access token
 * @param {Object} responseData.user_detail - User detail object
 */
export const handleOtpVerified = (responseData) => {
  return (dispatch) => {
    // Initialize auth data
    initializeAuthData(responseData)

    // Clear session ID as it's no longer needed
    setSessionId(null)

    // Dispatch Redux action
    dispatch({
      type: "OTP_VERIFIED",
      payload: {
        accessToken: responseData.access_token,
        userData: responseData.user_detail,
        isAuthenticated: true
      }
    })
  }
}

/**
 * Handle logout
 */
export const handleLogoutV2 = () => {
  return (dispatch) => {
    // Clear all auth data
    clearAuthData()

    // Dispatch Redux action
    dispatch({
      type: "LOGOUT_V2",
      payload: {
        isAuthenticated: false
      }
    })
  }
}

/**
 * Update user data (e.g., after profile update)
 * @param {Object} userData - Updated user data
 */
export const updateUserDataV2 = (userData) => {
  return (dispatch) => {
    // Update stored user data
    setUserData(userData)

    // Dispatch Redux action
    dispatch({
      type: "UPDATE_USER_DATA_V2",
      payload: {
        userData
      }
    })
  }
}

